import { render, staticRenderFns } from "./showdetails.vue?vue&type=template&id=e90fe31a&scoped=true"
import script from "./showdetails.vue?vue&type=script&lang=js"
export * from "./showdetails.vue?vue&type=script&lang=js"
import style0 from "./showdetails.vue?vue&type=style&index=0&id=e90fe31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90fe31a",
  null
  
)

export default component.exports